import BaseModel from './BaseModel';
import moment from 'moment';
import type { Moment } from 'moment';

class InAppNotification extends BaseModel {
    _id: string;
    createdAt?: Moment;
    updatedAt?: Moment;
    user: string;
    type: string;
    title: string;
    body?: string | null;
    link?: string | null;
    resourceType?: string | null;
    resourceId?: string | null;
    readAt?: Moment | null;

    constructor(properties: AnyObj) {
        super({});

        this._id          = properties._id;
        this.createdAt    = properties.createdAt ? moment(properties.createdAt) : undefined;
        this.updatedAt    = properties.updatedAt ? moment(properties.updatedAt) : undefined;
        this.user         = properties.user;
        this.type         = properties.type;
        this.title        = properties.title;
        this.body         = properties.body;
        this.link         = properties.link;
        this.resourceType = properties.resourceType;
        this.resourceId   = properties.resourceId;
        this.readAt       = properties.readAt ? moment(properties.readAt) : null;
    }
}

export default InAppNotification;
